import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const mediaTranscriptApiService = createApi({
  reducerPath: "mediaTranscriptApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    generateMediaTranscript: builder.mutation({
      query: ({ body }) => {
        return {
          url: `media-transcript/generate`,
          method: "POST",
          body,
        };
      },
    }),
    reGenerateMediaTranscript: builder.mutation({
      query: ({ id }) => {
        return {
          url: `media-transcript/${id}/regenerate`,
          method: "POST",
        };
      },
    }),
    getMediaTranscriptById: builder.query({
      query: ({ id }) => {
        return {
          url: `media-transcript/${id}`,
          method: "GET",
        };
      },
    }),
    updateMediaTranscript: builder.mutation({
      query: ({ id, body }) => {
        return {
          url: `media-transcript/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
    getByTranscriptMediaId: builder.query({
      query: ({ params }) => {
        let query = queryParams(params);
        return {
          url: `media-transcript${query}`,
          method: "GET",
        };
      },
    }),
    getbulkMediaTranscript: builder.query({
      query: ({ body }) => {
        return {
          url: `media-transcript/bulk`,
          method: "POST",
          body,
        };
      },
    }),
    deleteMediaTranscript: builder.mutation({
      query: ({ id }) => {
        return {
          url: `media-transcript/${id}`,
          method: "DELETE",
        };
      },
    }),
  }),
});

export const {
  useGenerateMediaTranscriptMutation,
  useReGenerateMediaTranscriptMutation,
  useGetMediaTranscriptByIdQuery,
  useLazyGetMediaTranscriptByIdQuery,
  useUpdateMediaTranscriptMutation,
  useGetByTranscriptMediaIdQuery,
  useGetbulkMediaTranscriptQuery,
  useDeleteMediaTranscriptMutation,
} = mediaTranscriptApiService;
